<script setup>
import { ref, watch, computed, onMounted, Fragment } from "vue";
import { useField } from "vee-validate";
import * as yup from "yup";

// Store instances

const props = defineProps({
  name: String,
  label: String,
  placeholder: String,
  max: Number,
  min: Number,
  schema: Object,
  modelValue: Number,
  initialValue: {
    type: Number,
    default: 0,
  },
  type: {
    type: String,
    default: "number",
  },
  required: {
    type: Boolean,
    default: true,
  },
});

const field = props.name;

// Create a schema field based on the required prop
let schema = yup.number();

if (props.schema) {
  schema = props.schema;
} else {
  schema = schema.required(
    props.required ? `${props.label} is required.` : undefined
  );
}
// Vee-validate field setup
const { value, errorMessage, validate } = useField(props.name, schema, {
  initialValue: props.modelValue || props.initialValue,
});

function increment() {
  value.value++;
}

function decrement() {
  // Prevents the count from going below 0 or the minimum val
  if (value.value > (props.min ?? 0)) value.value--;
}

// Define emits to declare event emission capability
const emit = defineEmits(["update:modelValue"]);

watch(value, (newValue) => {
  emit("update:modelValue", newValue);
});
</script>

<template>
  <fieldset class="frm-field">
    <label :for="name" class="block mb-10">
      {{ label }}
      <!-- <span v-if="required" class="text-red-500">*</span> -->
    </label>
    <div class="flex items-center px-15 max-w-[140px] frm-input">
      <button
        type="button"
        @click="decrement"
        class="self-stretch pr-10 border-grey-border border-r">
        <i class="text-blue ri-subtract-line"></i>
      </button>
      <input
        type="text"
        :id="name"
        :name="name"
        :placeholder="placeholder"
        v-model="value"
        class="px-20 w-full !h-auto text-center" />
      <button
        type="button"
        @click="increment"
        class="self-stretch pl-10 border-grey-border border-l">
        <i class="text-blue ri-add-line"></i>
      </button>
    </div>
    <span
      v-if="errorMessage"
      class="block mt-10 text-14 text-error leading-none">
      {{ errorMessage }}
    </span>
  </fieldset>
</template>
